import React from "react";
import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
  Cell,
} from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class BarChartStrategy extends ChartStrategy {
  render() {
    return (
      <BarChart {...this.commonProps}>
        <CartesianGrid stroke={this.props.gridColor} strokeDasharray="3 3" />
        <XAxis
          dataKey={this.props.xAxis}
          {...this.axisProps}
          tick={{ fill: this.props.axisColor, fontSize: 12, fontWeight: 500 }}
        />
        <YAxis
          {...this.axisProps}
          tick={{ fill: this.props.axisColor, fontSize: 12, fontWeight: 500 }}
        />
        <Tooltip
          content={<this.props.CustomTooltip />}
          cursor={{ fill: this.props.barHover, stroke: "none", opacity: 1 }}
        />
        <Legend wrapperStyle={{ color: this.props.axisColor, fontSize: 12 }} />
        <Bar dataKey={this.props.yAxis} radius={[5, 5, 0, 0]}>
          {this.props.normalizedData.map((d, i) => (
            <Cell
              key={i}
              fill={DYCHARTCOLORS[i % DYCHARTCOLORS.length]}
              cursor="pointer"
              stroke={this.props.darkMode ? "#1e293b" : "#fff"}
            />
          ))}
        </Bar>
      </BarChart>
    );
  }
}
